import React, { useState } from "react"
// import striptags from "striptags"

import {
  connectStateResults,
  Highlight,
  Hits,
  Index,
  Snippet,
} from "react-instantsearch-dom"


// Language
import { useTranslation } from 'react-i18next';


const HitsDialog = connectStateResults(({ allSearchResults, searchState }) => {

  const { t } = useTranslation()

  const totalHits = allSearchResults
    ? Object.values(allSearchResults).reduce((acc, { nbHits }) => acc + nbHits, 0)
    : 0;

  if(totalHits > 0){
    return (
      <div id="search-total-hits" className="mb-2">
        <span className="searching-for">{t('Stai cercando')}</span>
        <span className="searching-query">{searchState.query},</span>
        <span className="searching-total-number">{totalHits}</span>
        <span className="searching-total-string">{t('risultati trovati')}</span>
      </div>
    )
  } else {
    return (
      <div id="search-total-hits" className="mb-2">
        <span className="searching-for">{t('Stai cercando')}</span>
        <span className="searching-query">{searchState.query},</span>
        <span className="searching-total-string">{t('nessun risultato trovato.')}</span>
      </div>
    )
  }

});


export default HitsDialog
